// import React, { useState, useEffect } from "react";
// import { MdWork } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

// const RegisterStep5 = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     highestEducation: "",
//     employedIn: "",
//     occupation: "",
//     annualIncome: "",
//     workLocationCountry: "India",
//     work_location_state: "",
//     work_location_city: "",
//     ancestralOrigin: "",
//   });

//   const [formErrors, setFormErrors] = useState({});

//   const educationOptions = [
//     "High School", "Diploma", "B.A", "B.Sc", "B.Com", "B.Tech",
//     "B.E", "M.A", "M.Sc", "M.Com", "M.Tech", "M.E", "MBA", "PhD", "Other"
//   ];

//   const occupationOptions = [
//     "Software Engineer", "Doctor", "Teacher", "Government Employee",
//     "Business Owner", "Lawyer", "Accountant", "Architect", "Engineer", "Artist", "Other"
//   ];

//   const countryOptions = ["India", "Other"];
//   const stateOptions = [  "Rajasthan",
//   "Uttar Pradesh",
//   "Madhya Pradesh",
//   "Bihar",
//   "Himachal Pradesh",
//   "Uttarakhand",
//   "Gujarat",
//   "Haryana",
//   "Punjab",
//   "Jammu and Kashmir",
//   "Other",];
//   const cityOptions = [  "Jaipur",
//   "Jodhpur",
//   "Udaipur",
//   "Ajmer",
//   "Indore",
//   "Bhopal",
//   "Varanasi",
//   "Prayagraj",
//   "Lucknow",
//   "Patna",
//   "Gwalior",
//   "Delhi",
//   "Other",];

//   useEffect(() => {
//     const savedData = JSON.parse(localStorage.getItem("registrationData"));
//     if (savedData) {
//       setFormData(prev => ({
//         ...prev,
//         ...savedData
//       }));
//     }
//   }, []);

//   const validate = () => {
//     const errors = {};
//     if (!formData.highestEducation) errors.highestEducation = "Education is required";
//     if (!formData.employedIn) errors.employedIn = "Employment type is required";
//     if (!formData.occupation) errors.occupation = "Occupation is required";
//     if (!formData.annualIncome) errors.annualIncome = "Income is required";
//     if (!formData.workLocationCountry) errors.workLocationCountry = "Country is required";
//     if (!formData.work_location_state) errors.work_location_state = "State is required";
//     if (!formData.work_location_city) errors.work_location_city = "City is required";
//     if (!formData.ancestralOrigin) errors.ancestralOrigin = "Origin is required";
//     return errors;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     setFormErrors(prev => ({ ...prev, [name]: "" })); // clear error
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const errors = validate();
//     if (Object.keys(errors).length > 0) {
//       setFormErrors(errors);
//       return;
//     }
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     localStorage.setItem("registrationData", JSON.stringify({ ...existingData, ...formData }));
//     navigate("/register-step6-html");
//   };

//   const handleBack = () => {
//     const existingData = JSON.parse(localStorage.getItem("registrationData")) || {};
//     localStorage.setItem("registrationData", JSON.stringify({ ...existingData, ...formData }));
//     navigate("/register-step4-html");
//   };

//   const renderError = (field) =>
//     formErrors[field] ? (
//       <p className="text-red-500 text-sm mt-1">{formErrors[field]}</p>
//     ) : null;

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
//       <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">
//         <div className="md:w-1/2 bg-blue-50 flex flex-col justify-center items-center p-8">
//           <MdWork className="text-blue-600 text-7xl mb-6" />
//           <p className="text-xl md:text-2xl font-semibold text-blue-700 text-center">
//             Professional details help you get relevant matches
//           </p>
//         </div>

//         <div className="md:w-1/2 w-full p-8">
//           <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-1">
//             Professional Details
//           </h2>

//           <form onSubmit={handleSubmit} className="space-y-4 mt-4">
//             {/* Highest Education */}
//             <div>
//               <label className="block text-gray-700 mb-1">Highest Education</label>
//               <select
//                 name="highestEducation"
//                 value={formData.highestEducation}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               >
//                 <option value="">Select</option>
//                 {educationOptions.map(edu => (
//                   <option key={edu} value={edu}>{edu}</option>
//                 ))}
//               </select>
//               {renderError("highestEducation")}
//             </div>

//             {/* Employed In */}
//             <div>
//               <label className="block text-gray-700 mb-1">Employed In</label>
//               <select
//                 name="employedIn"
//                 value={formData.employedIn}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               >
//                 <option value="">Select</option>
//                 <option>Government/PSU</option>
//                 <option>Private</option>
//                 <option>Business</option>
//                 <option>Defence</option>
//                 <option>Self Employed</option>
//                 <option>Not working</option>
//               </select>
//               {renderError("employedIn")}
//             </div>

//             {/* Occupation */}
//             <div>
//               <label className="block text-gray-700 mb-1">Occupation</label>
//               <select
//                 name="occupation"
//                 value={formData.occupation}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               >
//                 <option value="">Select</option>
//                 {occupationOptions.map(occ => (
//                   <option key={occ} value={occ}>{occ}</option>
//                 ))}
//               </select>
//               {renderError("occupation")}
//             </div>

//             {/* Annual Income */}
//             <div>
//               <label className="block text-gray-700 mb-1">Annual Income</label>
//               <input
//                 type="text"
//                 name="annualIncome"
//                 value={formData.annualIncome}
//                 onChange={handleChange}
//                 placeholder="Rs. 3 - 4 Lakhs"
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               />
//               {renderError("annualIncome")}
//             </div>

//             {/* Country */}
//             <div>
//               <label className="block text-gray-700 mb-1">Work Location - Country</label>
//               <select
//                 name="workLocationCountry"
//                 value={formData.workLocationCountry}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               >
//                 {countryOptions.map(c => (
//                   <option key={c} value={c}>{c}</option>
//                 ))}
//               </select>
//               {renderError("workLocationCountry")}
//             </div>

//             {/* State */}
//             <div>
//               <label className="block text-gray-700 mb-1">State</label>
//               <select
//                 name="work_location_state"
//                 value={formData.work_location_state}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               >
//                 <option value="">Select</option>
//                 {stateOptions.map(state => (
//                   <option key={state} value={state}>{state}</option>
//                 ))}
//               </select>
//               {renderError("work_location_state")}
//             </div>

//             {/* City */}
//             <div>
//               <label className="block text-gray-700 mb-1">City</label>
//               <select
//                 name="work_location_city"
//                 value={formData.work_location_city}
//                 onChange={handleChange}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               >
//                 <option value="">Select</option>
//                 {cityOptions.map(city => (
//                   <option key={city} value={city}>{city}</option>
//                 ))}
//               </select>
//               {renderError("work_location_city")}
//             </div>

//             {/* Ancestral Origin */}
//             <div>
//               <label className="block text-gray-700 mb-1">Ancestral Origin</label>
//               <input
//                 type="text"
//                 name="ancestralOrigin"
//                 value={formData.ancestralOrigin}
//                 onChange={handleChange}
//                 placeholder="e.g., Madhya Pradesh"
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2"
//               />
//               {renderError("ancestralOrigin")}
//             </div>

//             {/* Buttons */}
//             <div className="flex gap-3 mt-2">
//               <button
//                 type="button"
//                 onClick={handleBack}
//                 className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded transition duration-200"
//               >
//                 Back
//               </button>
//               <button
//                 type="submit"
//                 className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded transition duration-200"
//               >
//                 Continue
//               </button>
//             </div>
//           </form>

//           <p className="text-xs text-center text-gray-400 mt-6">
//             Copyright © 2025. All rights reserved.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RegisterStep5;

import React, { useState, useEffect, useRef } from "react";
import { MdWork } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axiosInstance";

const RegisterStep5 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    highestEducation: "",
    employedIn: "",
    occupation: "",
    annualIncome: "",
    workLocationCountry: "India",
    work_location_state: "",
    work_location_city: "",
    ancestralOrigin: "",
  });

  const [formErrors, setFormErrors] = useState({});

  // Dropdown data fetched from the backend
  const [options, setOptions] = useState({
    education: [],
    employment_types: [],
    occupations: [],
  });
  const [optionsLoading, setOptionsLoading] = useState(true);
  const [optionsError, setOptionsError] = useState("");

  // PIN code lookup — kept entirely separate from formData
  const [pincode, setPincode] = useState("");
  const [pincodeStatus, setPincodeStatus] = useState("idle"); // idle | loading | success | error
  const debounceRef = useRef(null);

  const countryOptions = ["India", "Other"];

  /* Restore saved step data (and the last-used pincode, stored separately) */
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("registrationData"));
    if (savedData) {
      setFormData((prev) => ({ ...prev, ...savedData }));
    }
    const savedPincode = localStorage.getItem("tempWorkPincode");
    if (savedPincode) setPincode(savedPincode);
  }, []);

  /* Fetch dropdown options from the database-backed endpoint */
  useEffect(() => {
    const loadOptions = async () => {
      try {
        const res = await axios.get("/api/accounts/professional-options/");
        setOptions(res.data);
      } catch (err) {
        setOptionsError(
          "Could not load form options. Please refresh the page.",
        );
      } finally {
        setOptionsLoading(false);
      }
    };
    loadOptions();
  }, []);

  /* Debounced PIN code → state/city lookup */
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!/^\d{6}$/.test(pincode)) {
      setPincodeStatus("idle");
      return;
    }

    debounceRef.current = setTimeout(async () => {
      setPincodeStatus("loading");
      try {
        const res = await fetch(
          `https://api.postalpincode.in/pincode/${pincode}`,
        );
        const data = await res.json();
        const office = data?.[0]?.PostOffice?.[0];

        if (data?.[0]?.Status === "Success" && office) {
          setFormData((prev) => ({
            ...prev,
            work_location_state: office.State,
            work_location_city: office.District,
          }));
          setFormErrors((prev) => ({
            ...prev,
            work_location_state: "",
            work_location_city: "",
          }));
          setPincodeStatus("success");
        } else {
          setPincodeStatus("error");
          setFormData((prev) => ({
            ...prev,
            work_location_state: "",
            work_location_city: "",
          }));
        }
      } catch (err) {
        setPincodeStatus("error");
      }
    }, 600);

    return () => clearTimeout(debounceRef.current);
  }, [pincode]);

  const validate = () => {
    const errors = {};
    if (!formData.highestEducation)
      errors.highestEducation = "Education is required";
    if (!formData.employedIn) errors.employedIn = "Employment type is required";
    if (!formData.occupation) errors.occupation = "Occupation is required";
    if (!formData.annualIncome) errors.annualIncome = "Income is required";
    if (!formData.workLocationCountry)
      errors.workLocationCountry = "Country is required";
    if (!pincode) errors.pincode = "Pincode is required";
    if (!formData.work_location_state)
      errors.work_location_state = "Enter a valid pincode to detect state";
    if (!formData.work_location_city)
      errors.work_location_city = "Enter a valid pincode to detect city";
    if (!formData.ancestralOrigin)
      errors.ancestralOrigin = "Origin is required";
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setPincode(value);
    setFormErrors((prev) => ({ ...prev, pincode: "" }));
  };

  const persistStepData = () => {
    const existingData =
      JSON.parse(localStorage.getItem("registrationData")) || {};
    // Note: pincode is intentionally NOT merged into registrationData
    localStorage.setItem(
      "registrationData",
      JSON.stringify({ ...existingData, ...formData }),
    );
    localStorage.setItem("tempWorkPincode", pincode);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    persistStepData();
    navigate("/register-step6-html");
  };

  const handleBack = () => {
    persistStepData();
    navigate("/register-step4-html");
  };

  const renderError = (field) =>
    formErrors[field] ? (
      <p className="text-red-500 text-sm mt-1">{formErrors[field]}</p>
    ) : null;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white shadow-lg rounded-2xl flex flex-col md:flex-row w-full max-w-4xl overflow-hidden">
        <div className="md:w-1/2 bg-blue-50 flex flex-col justify-center items-center p-8">
          <MdWork className="text-blue-600 text-7xl mb-6" />
          <p className="text-xl md:text-2xl font-semibold text-blue-700 text-center">
            Professional details help you get relevant matches
          </p>
        </div>

        <div className="md:w-1/2 w-full p-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-1">
            Professional Details
          </h2>

          {optionsError && (
            <p className="text-red-500 text-sm mt-2">{optionsError}</p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            {/* Highest Education */}
            <div>
              <label className="block text-gray-700 mb-1">
                Highest Education
              </label>
              <select
                name="highestEducation"
                value={formData.highestEducation}
                onChange={handleChange}
                disabled={optionsLoading}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              >
                <option value="">
                  {optionsLoading ? "Loading..." : "Select"}
                </option>
                {options.education.map((edu) => (
                  <option key={edu.id} value={edu.name}>
                    {edu.name}
                  </option>
                ))}
              </select>
              {renderError("highestEducation")}
            </div>

            {/* Employed In */}
            <div>
              <label className="block text-gray-700 mb-1">Employed In</label>
              <select
                name="employedIn"
                value={formData.employedIn}
                onChange={handleChange}
                disabled={optionsLoading}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              >
                <option value="">
                  {optionsLoading ? "Loading..." : "Select"}
                </option>
                {options.employment_types.map((et) => (
                  <option key={et.id} value={et.name}>
                    {et.name}
                  </option>
                ))}
              </select>
              {renderError("employedIn")}
            </div>

            {/* Occupation */}
            <div>
              <label className="block text-gray-700 mb-1">Occupation</label>
              <select
                name="occupation"
                value={formData.occupation}
                onChange={handleChange}
                disabled={optionsLoading}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              >
                <option value="">
                  {optionsLoading ? "Loading..." : "Select"}
                </option>
                {options.occupations.map((occ) => (
                  <option key={occ.id} value={occ.name}>
                    {occ.name}
                  </option>
                ))}
              </select>
              {renderError("occupation")}
            </div>

            {/* Annual Income */}
            <div>
              <label className="block text-gray-700 mb-1">Annual Income</label>
              <input
                type="text"
                name="annualIncome"
                value={formData.annualIncome}
                onChange={handleChange}
                placeholder="Rs. 3 - 4 Lakhs"
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              />
              {renderError("annualIncome")}
            </div>

            {/* Country */}
            <div>
              <label className="block text-gray-700 mb-1">
                Work Location - Country
              </label>
              <select
                name="workLocationCountry"
                value={formData.workLocationCountry}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              >
                {countryOptions.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              {renderError("workLocationCountry")}
            </div>

            {/* Pincode → auto-fills State & City */}
            <div>
              <label className="block text-gray-700 mb-1">
                Work Location - Pincode
              </label>
              <input
                type="text"
                inputMode="numeric"
                value={pincode}
                onChange={handlePincodeChange}
                placeholder="e.g., 302001"
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              />
              {pincodeStatus === "loading" && (
                <p className="text-gray-500 text-sm mt-1">
                  Looking up state & city…
                </p>
              )}
              {pincodeStatus === "error" && (
                <p className="text-red-500 text-sm mt-1">
                  Could not find this pincode. Please check and try again.
                </p>
              )}
              {renderError("pincode")}
            </div>

            {/* Detected State (read-only, auto-filled) */}
            <div>
              <label className="block text-gray-700 mb-1">State</label>
              <input
                type="text"
                value={formData.work_location_state}
                readOnly
                placeholder="Auto-filled from pincode"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100"
              />
              {renderError("work_location_state")}
            </div>

            {/* Detected City (read-only, auto-filled) */}
            <div>
              <label className="block text-gray-700 mb-1">City</label>
              <input
                type="text"
                value={formData.work_location_city}
                readOnly
                placeholder="Auto-filled from pincode"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100"
              />
              {renderError("work_location_city")}
            </div>

            {/* Ancestral Origin */}
            <div>
              <label className="block text-gray-700 mb-1">
                Ancestral Origin
              </label>
              <input
                type="text"
                name="ancestralOrigin"
                value={formData.ancestralOrigin}
                onChange={handleChange}
                placeholder="e.g., Madhya Pradesh"
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
              />
              {renderError("ancestralOrigin")}
            </div>

            {/* Buttons */}
            <div className="flex gap-3 mt-2">
              <button
                type="button"
                onClick={handleBack}
                className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 rounded transition duration-200"
              >
                Back
              </button>
              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 rounded transition duration-200"
              >
                Continue
              </button>
            </div>
          </form>

          <p className="text-xs text-center text-gray-400 mt-6">
            Copyright © Jain Var Vadhu. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterStep5;
